(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["our-story-chapters"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-craft"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(!window.__spReveal){window.__spReveal=1;var run=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?run():document.addEventListener('DOMContentLoaded',run);}
  document.querySelectorAll('[data-sp-video]').forEach(function(v){var s=parseFloat(v.dataset.s)||0,e=parseFloat(v.dataset.e)||0;v.addEventListener('loadedmetadata',function(){if(s)v.currentTime=s;v.play().catch(function(){});});v.addEventListener('timeupdate',function(){if(e&&(v.currentTime>=e||v.currentTime<s))v.currentTime=s;});});
  // Size the hero to fill from its own top edge to the viewport bottom, so a theme header sitting
  // above it never pushes the bottom-aligned content off-screen (fixes clipped CTA / content too low).
  var fit=function(){document.querySelectorAll('[data-sp-hero]').forEach(function(h){var top=h.getBoundingClientRect().top+(window.pageYOffset||document.documentElement.scrollTop||0);h.style.minHeight=Math.max(560,window.innerHeight-top)+'px';});};
  fit();window.addEventListener('resize',fit);window.addEventListener('load',fit);
  // "Read our story" (and any empty-link CTA) smooth-scrolls to the next section instead of jumping to top.
  document.querySelectorAll('[data-sp-scroll-next]').forEach(function(a){a.addEventListener('click',function(ev){var href=a.getAttribute('href')||'';if(href===''||href==='#'){ev.preventDefault();var sec=a.closest('section'),n=sec?sec.nextElementSibling:null;while(n&&n.tagName!=='SECTION'){n=n.nextElementSibling;}if(n){n.scrollIntoView({behavior:'smooth',block:'start'});}else{window.scrollTo({top:window.innerHeight,behavior:'smooth'});}}});});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-made-in-uk"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-products"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-stats"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-testimonial"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-timeline"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}
document.querySelectorAll('[data-sp-toggle]').forEach(function(btn){var tl=btn.closest('section').querySelector('[data-sp-tl]');var lbl=btn.querySelector('[data-l]');var more=lbl?lbl.textContent:'Show more';btn.addEventListener('click',function(){var o=tl.classList.toggle('open');if(lbl)lbl.textContent=o?'Show less':more;tl.querySelectorAll('.sp-tl__row.x .sp-reveal').forEach(function(el){el.classList.add('is-in');});});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-trust"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-values"] && !Shopify.designMode) return;
  try {
    
if(!window.__spReveal){window.__spReveal=1;var _r=function(){var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});document.querySelectorAll('.sp-reveal').forEach(function(el){io.observe(el);});};document.readyState!=='loading'?_r():document.addEventListener('DOMContentLoaded',_r);}

  } catch(e) { console.error(e); }
})();
})();
